export const SET_TEXTS = 'TEXTS/SET_TEXTS';

export const setTexts = textsData => ({
  type: SET_TEXTS,
  payload: textsData,
});
